import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getSharedInquiryResponse, shareInquiryResponse } from '@api/inquiries';
import {
  ISharedInquiryResponse,
  IShareInquiryResponsePayload,
  IShareInquiryResponseResult,
} from '@interfaces/inquiries';

export const handleShareInquiryResponse = createAsyncThunk<
  AxiosResponse<IShareInquiryResponseResult>,
  IShareInquiryResponsePayload
>('shareInquiryResponse', shareInquiryResponse);

export const handleGetSharedInquiryResponse = createAsyncThunk<
  AxiosResponse<ISharedInquiryResponse>,
  string
>('getSharedInquiryResponse', getSharedInquiryResponse);
